import { styled } from "styled-components";

/** Styled div for all Messages (Chat & Debug messages) */
export const MessageContainer = styled.div(({ theme }) => {
  return {
    display: "inline-block",
    boxSizing: "border-box",
    padding: "10px 14px",
    borderRadius: theme.radii[1],
    overflowWrap: "anywhere",
    width: "fit-content",
    // max-width is also set on the SystemMessage component, but this keeps User and System messages the same length
    maxWidth: "480px",
  };
});

interface ChatMessageProps {
  /** Who sent the message? */
  $from: "system" | "user";
}

/** Container for "system" and "user" messages */
export const ChatMessage = styled(MessageContainer)<ChatMessageProps>(({
  theme,
  $from,
}) => {
  const userStyles = {
    color: theme.colors.white,
    backgroundColor: theme.colors.primary,
    whiteSpace: "break-spaces",
  };

  const systemStyles = {
    color: theme.colors.black,
    backgroundColor: theme.colors.grayLight,
  };

  if ($from === "system") {
    return systemStyles;
  } else {
    return userStyles;
  }
});

export interface DebugMessageProps {
  /** Orientation of the debug message */
  $orientation: "left" | "right" | "center";
}

/** Container for debug message */
export const DebugMessage = styled(MessageContainer)<DebugMessageProps>(({
  theme,
  $orientation,
}) => {
  return {
    position: "relative",
    marginTop: 6,
    border: `1px solid ${theme.colors.grayMed}`,
    padding: "10px 14px",
    backgroundColor: theme.colors.white,
    boxShadow: `0 1px 2px ${theme.shadows[2]}`,
    color: theme.colors.grayDark,
    textAlign: $orientation,
  };
});
